export const headerCellTitlesOfData = [
  {'name': 'Código de repuesto', 'serializedName': 'partNo', 'width': '250px', 'required': true, 'maxLength': '20'},
  {'name': 'Descripción', 'serializedName': 'name', 'width': '75px', 'required': true, 'maxLength': '4'},
  {'name': 'Product Code', 'serializedName': 'product', 'width': '75px', 'required': true, 'maxLength': '4'},
];

export const headerCellTitlesOfControl = [
  {'name': 'Acciones', 'width': '100px'},
];
